import React from 'react'

import { learningObjectivesIntro, activitiesListIntro, standardActivities, initialPost, standardActivitiesClosing, closing, estimated } from './AL00000Sprint00'
import { oreillyPlaylistSC, continuousIntegration, externalLink } from '../DataAndAPIs/Links'

import { gettingToKnowEachOthersTeamsLink } from '../Activities/WebGettingToKnowEachOthersTeams'
// import { azureWebsiteLink } from '../Activities/AzureWebsite'

import { HTMLW3C, CSSW3C, JavaScriptW3C } from '../DataAndAPIs/Links'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
// import { gettingToKnowEachOtherLink } from '../Activities/WebGettingToKnowEachOther'
import { capstoneSprint2Link, celebrationOfScholarshipDescription, celebrationOfScholarshipDate, recruitmentEventDate } from '../Activities/ClassProduct'

export const lectureRecordingPlaylist = () => { return externalLink('lecture', 'https://lewisu.hosted.panopto.com/Panopto/Pages/Viewer.aspx?pid=50ad011a-766e-43e7-8ec4-ae2301373d46')}
// export const celebrationOfScholarship = () => { return externalLink('Celebration of Scholarship', 'https://www.lewisu.edu/cos') }
export const celebrationOfScholarship = () => { return 'midterm Product Review '}

// export const celebrationOfScholarshipRegistration = () => { return externalLink('Celebration of Scholarship Registration', 'https://www.lewisu.edu/celebration-scholarship/gettingstarted.htm?mode=&id=research-presentations') }
export const celebrationOfScholarshipRegistration = () => { return 'midterm Product Review '}

export const al49200Sprint02 = () => {
	const sprint = 2
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>

		<p><em>Welcome back.</em> Now that we are comfortable with our teams and the new semester, it’s time to focus on enhancing our 
		product. Our first step in consistently delivering enhancements to customers is to validate our continuous 
		integration / continuous delivery (CI/CD). <em>CI/CD</em> is often much harder than it sounds. Done well, CI/CD allows a team to 
		consistently release new functionality to development, test, and production environments without introducing defects. How will you 
		ensure your team is able to safely implement, test, and demonstrate new functionality?</p>

		<p>The second step in consistently delivering product enhancements to costumers is to <em>have costumers who utilize
		the enhancements</em>. In order to attract customers, we need demonstrate the value of our features to customers. 
		One place we will be showcasing these enhancements is our {celebrationOfScholarshipDescription} {celebrationOfScholarship()}. Mark 
		your calendar for {celebrationOfScholarshipDate} where you and your team be sharing your product enhancements with 
		your instructor and Software Engineering team.</p>

		<p>In addition, you will be recruiting your future product development team for the current Software Engineering class
		on {recruitmentEventDate}. This is also an opportunity to get new product users (customers) in addition to future
		developers. Participation in both events is required for the full team. The Product Owner for this sprint will 
		lead the completion of {celebrationOfScholarshipDescription} {celebrationOfScholarshipRegistration()} while the product owner 
		for next sprint will lead the effort to recruit the future delivery team.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Prepare to recruit future developers from Software Engineering on {recruitmentEventDate}</li>
			<li>Prepare for {celebrationOfScholarshipDescription} {celebrationOfScholarship()}</li>
			<li>Understand Configuration Management and Continuous Integration and Continuous Deployment (CI/CD)</li>
			<li>Implement, document, and demonstrate CI/CD for your product team’s development, test, and productions environments</li>
			<li>Implement, document, and demonstrate CI/CD for your customer’s access to test, and productions environments</li>
		</ul>

		{list49200Sprint02(sprint)}
		{closing(sprint)}
	</div> )
}

export const list49200Sprint02 = (sprint) => {
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, capstoneSprint2Link())}
			<li>Reserve {celebrationOfScholarshipDate} for your in-person {celebrationOfScholarshipDescription}</li>
			<li>Read {continuousIntegration()}</li>
			<li>Within {oreillyPlaylistSC()} read “Essential Scrum” chapters 7 through 10</li>

			<li>As needed review {HTMLW3C()}, {CSSW3C()}, and {JavaScriptW3C()} tutorials</li>
			{initialPost(sprint)}

			<li>Prepare to recruit your future development team from the Software Engineering class on {recruitmentEventDate}</li>
			<li>With your team complete {gettingToKnowEachOthersTeamsLink()}{estimated('2 hours')}</li> 
			<li>Within {oreillyPlaylistSC()} read “Essential Scrum” chapters 11 and 12</li>
			{standardActivitiesClosing(sprint, capstoneSprint2Link(), '12 hours per team member')}
		</ol>
	</div> )
}

// Certified for FA25 on September 6, 2025



